import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import Main from "./components/MainContainer.js";
import store from "./store.js";
import "./index.css";
import "./theme.css";
import reportWebVitals from "./reportWebVitals.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Main />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
